<script setup lang="ts">
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app';
import { ensureLogin } from '@/api/utils/auth';
import { applyCipherFonts } from '@/utils/cipherFontLoader';

let loginRetryCount = 0;
const MAX_LOGIN_RETRY = 2;

onLaunch(() => {
  console.log('App Launch');
  // 密文字体：启动时拉取 CSS 索引，CipherText 渲染时按码点按需 loadFontFace
  applyCipherFonts();








  attemptLogin();
});

async function attemptLogin() {
  try {
    await ensureLogin();
    loginRetryCount = 0;
  } catch (error) {
    console.error('登录失败:', error);
    loginRetryCount++;

    if (loginRetryCount < MAX_LOGIN_RETRY) {
      console.log(`登录失败，第 ${loginRetryCount} 次重试...`);
      setTimeout(() => {
        attemptLogin();
      }, 2000);
    } else {
      console.error('登录重试次数已达上限，停止重试');
      uni.showToast({
        title: '网络连接失败，请检查网络设置',
        icon: 'none',
        duration: 3000,
      });
    }
  }
}

onShow((options: any) => {
  console.log('App Show');
  const query = options?.query || {};










  // 兼容旧版登录码（未指定 page，先打开首页再跳转确认页）
  if (query.scene) {
    console.log('检测到scene参数，跳转到登录确认页面');
    uni.navigateTo({
      url: `/pages/login-confirm/login-confirm?scene=${encodeURIComponent(query.scene)}`,
    });
  }
});

onHide(() => {
  console.log('App Hide');
});
</script>
